import { render, staticRenderFns } from "./trainCourseScore.vue?vue&type=template&id=42392c63&scoped=true"
import script from "./trainCourseScore.vue?vue&type=script&lang=js"
export * from "./trainCourseScore.vue?vue&type=script&lang=js"
import style0 from "./trainCourseScore.vue?vue&type=style&index=0&id=42392c63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42392c63",
  null
  
)

export default component.exports